module.exports = require('./lib/for-each-key');
